import mcc from './MainContainerComponents.module.scss';
import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Drawer, Form, Input, Flex, Typography } from 'antd';
import theme from '../../utils/themes/Themes.module.scss';
import { getCookie, setCookie } from 'cookies-next';
import { ILoginBody } from 'tkmp-lib/src/interfaces';
import { AuthService } from 'tkmp-lib/src/services/AuthService';
import { observer } from 'mobx-react-lite';
import { useStores } from '@/utils/hooks/useStores';
import { QueryService } from 'tkmp-lib/src/services/QueryService';
import { usePopup } from 'tkmp-lib/src/hooks/usePopup';
import useLocalization from 'tkmp-lib/src/hooks/useLocalization';
import { IModalProps } from 'tkmp-lib/src/interfaces';
import { usePathname, useRouter } from 'next/navigation';

const { Text } = Typography;

// @ts-ignore
const DrawerLoginForm = observer(({ callback_close, callback_open }: IModalProps) => {
    const LOCALIZATION = useLocalization();
    const [form] = Form.useForm();
    const router = useRouter();
    const pathname = usePathname();

    const [forgotForm] = Form.useForm();

    const {
        userStore: { setUserName, setUserRole, setTokenExpirationInterval },
        modalsStore: { openRegisterForm },
    } = useStores();

    const [isForgotPasswordView, setIsForgotPasswordView] = useState<boolean>(false);
    const [isSuccessForgot, setIsSuccessForgot] = useState<boolean>(false);

    const [isFailedLogin, setIsFailedLogin] = useState<boolean>(false);
    const [isPending, setIsPending] = useState<boolean>(false);

    useEffect(() => {
        if (isFailedLogin) {
            setTimeout(() => {
                setIsFailedLogin(false);
            }, 2000);
        }
    }, [isFailedLogin]);

    useEffect(() => {
        if (isSuccessForgot) {
            setTimeout(() => {
                setIsSuccessForgot(false);
            }, 5000);
        }
    }, [isSuccessForgot]);

    const { message } = usePopup();

    const callback_submit = (values: ILoginBody) => {
        setIsPending(true);
        AuthService.login(values).then((answer) => {
            if (process.env.NEXT_PUBLIC_DEBUG === 'true') console.log('Login answer:', answer);
            setIsPending(false);
            if (answer.status) {
                if (!answer.status) {
                    setIsFailedLogin(true);
                    return;
                }
                setUserName(answer.name ?? 'Пользователь');
                setUserRole(answer.role);
                setTokenExpirationInterval(answer.expired);
                callback_close();
                form.setFieldsValue({
                    email: '',
                    password: '',
                });

                router.refresh();
            } else {
                message.error('Авторизация неуспешная!');
                setIsFailedLogin(true);
            }
        });
    };

    const callback_submit_forgot = (values: any) => {
        setIsPending(true);
        QueryService.request(
            `${process.env.NEXT_PUBLIC_DOMAIN_ID}/tkmp/v1/account/password/reset`,
            {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${getCookie('accessToken')}`,
                },
            },
        ).then((response: any) => {
            setIsPending(false);
            setIsSuccessForgot(response?.sendEmail);
            setCookie('accessToken', response?.token);
        });
    };

    return (
        <Drawer
            open={callback_open}
            onClose={() => {
                callback_close();
                setIsForgotPasswordView(false);
                setIsSuccessForgot(false);
            }}
            className={mcc.drawer}
            width={450}
        >
            {isForgotPasswordView ? (
                <Flex className={mcc.drawer_Form}>
                    <Form
                        form={forgotForm}
                        className={mcc.drawer_Form}
                        layout={'vertical'}
                        variant={'outlined'}
                        style={{
                            maxWidth: '100%',
                        }}
                        onFinish={(values) => callback_submit_forgot(values)}
                        clearOnDestroy
                    >
                        <Flex
                            className={`${theme.GeneralContainer__Theme} ${mcc.drawer_formBlock}`}
                            vertical
                            justify={'center'}
                            align={'center'}
                            style={{ height: '100%', width: '100%' }}
                        >
                            <Flex
                                align={'flex-start'}
                                style={{ width: '100%' }}
                            >
                                <Text className={mcc.drawer_title}>
                                    {isSuccessForgot
                                        ? LOCALIZATION.modals.login.formForgot.titleSuccess
                                        : LOCALIZATION.modals.login.formForgot.title}
                                </Text>
                            </Flex>
                            {isSuccessForgot ? (
                                <Flex>
                                    <Text className={`text-16-500`}>
                                        {LOCALIZATION.modals.login.formForgot.hintProgress}
                                    </Text>
                                </Flex>
                            ) : (
                                <Flex
                                    vertical
                                    align={'flex-start'}
                                    style={{ width: '100%' }}
                                    gap={'small'}
                                >
                                    <Text>{LOCALIZATION.modals.login.formForgot.hint}</Text>
                                    <Form.Item
                                        style={{ width: '100%' }}
                                        className={mcc.drawer_formItem}
                                        layout="vertical"
                                        label={LOCALIZATION.modals.login.formForgot.email.title}
                                        name="email"
                                        rules={[{ required: true, type: 'email' }]}
                                    >
                                        <Input placeholder={'example@example.example'} />
                                    </Form.Item>
                                </Flex>
                            )}
                            <Flex
                                justify={isSuccessForgot ? 'center' : 'space-between'}
                                style={{ width: '100%' }}
                            >
                                <Button
                                    size={'large'}
                                    onClick={() => {
                                        setIsForgotPasswordView(false);
                                    }}
                                    type={'text'}
                                    style={{ color: '#8D24F8', padding: '0' }}
                                >
                                    {LOCALIZATION.modals.login.formForgot.buttons.back}
                                </Button>
                                {!isSuccessForgot && (
                                    <Button
                                        size={'large'}
                                        htmlType={'submit'}
                                        disabled={isPending}
                                        loading={isPending}
                                    >
                                        {LOCALIZATION.modals.login.formForgot.buttons.submit}
                                    </Button>
                                )}
                            </Flex>
                        </Flex>
                    </Form>
                </Flex>
            ) : (
                <Form
                    form={form}
                    className={mcc.drawer_Form}
                    layout={'vertical'}
                    variant={'outlined'}
                    style={{
                        maxWidth: '100%',
                    }}
                    onFinish={(values) => callback_submit(values)}
                    clearOnDestroy
                >
                    <Flex
                        className={`${theme.GeneralContainer__Theme} ${mcc.drawer_formBlock}`}
                        vertical
                        justify={'center'}
                        align={'center'}
                        style={{ height: '100%' }}
                    >
                        <Flex
                            align={'flex-start'}
                            style={{ width: '100%' }}
                        >
                            <Text className={mcc.drawer_title}>
                                {LOCALIZATION.modals.login.title}
                            </Text>
                        </Flex>
                        <Form.Item
                            style={{ width: '100%' }}
                            className={mcc.drawer_formItem}
                            layout="vertical"
                            label={LOCALIZATION.modals.login.formLogin.email.title}
                            name="email"
                            rules={[
                                {
                                    required: true,
                                    type: 'email',
                                    message: LOCALIZATION.modals.login.formLogin.email.errorMessage,
                                },
                            ]}
                        >
                            <Input
                                autoComplete={'email'}
                                placeholder={'example@example.example'}
                            />
                        </Form.Item>
                        <Form.Item
                            style={{ width: '100%', margin: 0 }}
                            className={mcc.formItem}
                            layout="vertical"
                            label={LOCALIZATION.modals.login.formLogin.password.title}
                            name="password"
                            rules={[
                                {
                                    required: true,
                                    message:
                                        LOCALIZATION.modals.login.formLogin.password.errorMessage,
                                },
                            ]}
                        >
                            <Input.Password
                                autoComplete={'current-password'}
                                placeholder={
                                    LOCALIZATION.modals.login.formLogin.password.placeholder
                                }
                            />
                        </Form.Item>
                        <Flex
                            align={'baseline'}
                            justify={'space-between'}
                            style={{ width: '100%' }}
                        >
                            <Flex
                                align={'baseline'}
                                gap={'small'}
                                justify={'flex-start'}
                            >
                                <Form.Item
                                    style={{ margin: 0 }}
                                    className={mcc.formItem}
                                    name="remember"
                                    rules={[{ required: false }]}
                                    valuePropName={'checked'}
                                    noStyle
                                >
                                    <Checkbox />
                                </Form.Item>
                                <Text>{LOCALIZATION.modals.login.formLogin.remember}</Text>
                            </Flex>
                            <Button
                                onClick={() => {
                                    setIsForgotPasswordView(true);
                                }}
                                type={'text'}
                                style={{ color: '#8D24F8', padding: '0' }}
                            >
                                {LOCALIZATION.modals.login.formLogin.forgot}
                            </Button>
                        </Flex>
                        <Button
                            size={'large'}
                            loading={isPending}
                            disabled={isFailedLogin}
                            htmlType={'submit'}
                            style={{ width: '100%' }}
                        >
                            {isFailedLogin
                                ? LOCALIZATION.modals.login.formLogin.buttons.errorSubmit
                                : LOCALIZATION.modals.login.formLogin.buttons.submit}
                        </Button>
                        <Button
                            size={'large'}
                            onClick={() => {
                                callback_close();
                                openRegisterForm();
                            }}
                            ghost
                            style={{ width: '100%' }}
                        >
                            {LOCALIZATION.modals.login.formLogin.buttons.register}
                        </Button>
                    </Flex>
                </Form>
            )}
        </Drawer>
    );
});

export default DrawerLoginForm;
